module.exports = __webpack_public_path__ + "img/partner3.33e1cbd6.png";